var _path, _circle, _path2, _rect, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgScout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.528 35.776c10.159 4.234 27.04 4.753 29.206 8.987 2.241 4.307-10.158 12.403-19.794 15.596-9.561 3.268-16.359 1.708-22.708 6.239-6.424 4.456-12.474 15.002-19.123 17.007-6.722 2.08-14.043-4.382-15.686-11.808-1.718-7.501 2.316-15.968 2.839-26.143.597-10.1-2.316-21.91 1.792-27.182 4.183-5.273 15.313-4.085 22.634.52 7.32 4.604 10.681 12.551 20.84 16.784z",
    fill: "#EDF7FE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 53,
    r: 24,
    fill: "#2196F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.545 54.625c1.804 0 3.568-.52 5.068-1.495a8.933 8.933 0 003.362-3.983 8.65 8.65 0 00.52-5.13 8.803 8.803 0 00-2.499-4.544 9.208 9.208 0 00-4.671-2.428 9.364 9.364 0 00-5.27.505 9.075 9.075 0 00-4.096 3.268 8.703 8.703 0 00-1.54 4.932c0 2.355.963 4.613 2.675 6.277a9.257 9.257 0 006.45 2.598zm0-15.497c1.36 0 2.69.392 3.82 1.127a6.725 6.725 0 012.532 2.998c.52 1.22.656 2.563.391 3.858a6.624 6.624 0 01-1.88 3.42 6.939 6.939 0 01-3.521 1.83 7.061 7.061 0 01-3.974-.381 6.836 6.836 0 01-3.085-2.461 6.547 6.547 0 01-1.158-3.71c0-1.771.723-3.47 2.012-4.723a6.978 6.978 0 014.863-1.958zM87.385 55.872h.32c5.298 0 8.172.367 10.571 2.422 2.036 1.73 2.455 4.554 1.319 8.336a1.281 1.281 0 01-.478.68 1.338 1.338 0 01-.803.255H76.775h0v-.125a1.223 1.223 0 01-.726-.233 1.167 1.167 0 01-.434-.613l11.77-10.722zm0 0c-5.318 0-8.172.367-10.57 2.422-2.058 1.73-2.445 4.565-1.32 8.336l11.89-10.758zm10.234 9.499H77.472c-.18-.706-.382-1.681-.347-2.662.037-1.025.333-2.04 1.172-2.767 1.71-1.483 4.284-1.914 9.078-1.914h.34c4.796 0 7.238.305 9.078 1.913.906.792 1.205 1.81 1.228 2.814.023.965-.21 1.91-.402 2.616z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.25
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1.5,
    y: 1.5,
    width: 53,
    height: 39,
    rx: 4.5,
    transform: "matrix(-1 0 0 1 87 64)",
    fill: "#fff",
    stroke: "#2196F3",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.72139 .69253 -.32202 .94673 37 69)",
    stroke: "#2196F3",
    strokeWidth: 2,
    d: "M0-1h34.656"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-.72139 .69253 .32202 .94673 87 69)",
    stroke: "#2196F3",
    strokeWidth: 2,
    d: "M0-1h34.656"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2196F3",
    strokeWidth: 3,
    strokeLinecap: "round",
    d: "M24.5 91.5h5M16.5 96.5h13M8.5 101.5h21"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2196F3",
    strokeWidth: 2,
    d: "M69.707 85.293l17 17M54.353 85.647l-17 16.999"
  })));
}

export default SvgScout;